import { Injectable } from '@angular/core';
import { HomeTabs } from '@local/client-contracts';
import { generateId, isHeaderWidget } from '@local/common-web';
import { SETTINGS_WIDGET, WidgetsService } from './widgets.service';
import { observable } from '@local/common';
import { HomeTabsService } from 'src/app/bar/services/home-tabs.service';
import { ReplaySubject, distinctUntilChanged, filter, map } from 'rxjs';

@Injectable()
export class HeaderWidgetService {
  private allHeaders$ = new ReplaySubject<HomeTabs.HeaderWidget[]>(1);

  @observable
  get$(id: string) {
    return this.allHeaders$.pipe(
      map((c) => c?.find((c) => c.id === id)),
      distinctUntilChanged()
    );
  }

  constructor(private widgetsService: WidgetsService, private homeTabsService: HomeTabsService) {
    this.homeTabsService.all$.subscribe((all) => {
      const allHeaders: HomeTabs.HeaderWidget[] = [];
      all.forEach((tab) => {
        tab.widgets?.forEach((widget) => {
          if (isHeaderWidget(widget)) {
            allHeaders.push(widget);
          }
        });
      });
      this.allHeaders$.next(allHeaders);
    });
  }

  async createHeaderWidget(tabId: string, title?: string, alignTo?: HomeTabs.TextAlign) {
    const id = generateId();
    const headerWidget: HomeTabs.HeaderWidget = {
      title: title || 'Untitled',
      tabId,
      id,
      type: 'header',
      alignTo: alignTo || 'left',
      viewSetting: { cols: SETTINGS_WIDGET.maxCols, rows: SETTINGS_WIDGET.minRows, x: 0, y: 0 },
    };
    this.widgetsService.editMode = true;
    return this.widgetsService.add(tabId, headerWidget, true);
  }
}
